import React from 'react';
import { TFunction } from 'i18next';
import type { Dispatch } from 'redux';

import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { OpSpace } from 'new-components/DLS/OpSpace/OpSpace';
import { addSlideOut } from 'global/slideOuts/actions';
import alarmEditRouteConfig from 'routes/AlarmDashboardPage/AlarmEditPage/route';

import type { NotificationAlert } from './notificationService';

export function buildNotificationActions(
  alert: NotificationAlert,
  close: () => void,
  context: {
    dispatch: Dispatch;
    t: TFunction;
    canEditAlarms: boolean;
  },
): React.ReactNode {
  const { dispatch, t, canEditAlarms } = context;
  const { alertButtons } = alert;

  if (!alertButtons?.length) return undefined;

  return (
    <OpSpace>
      {alertButtons.map((button, index) => {
        const { resourceType, resourceUid } = button.target || {};
        const key =
          resourceType && resourceUid
            ? `${resourceType}-${resourceUid}`
            : `button-${index}`;

        switch (resourceType) {
          case 'alarm':
            if (resourceUid && canEditAlarms) {
              return (
                <OpButton
                  key={key}
                  onClick={() => {
                    close();
                    dispatch(
                      addSlideOut({
                        routeConfig: {
                          ...alarmEditRouteConfig,
                          extraData: {
                            alarmIdExt: resourceUid,
                          },
                        },
                        slideOutProps: {
                          requiredExtraData: ['alarmIdExt'],
                          pathname: null,
                          debug:
                            window.sessionStorage.getItem('op-history-debug') ??
                            undefined,
                        },
                      }),
                    );
                  }}
                  style={{ marginRight: 8 }}
                >
                  {t('View Alarm')}
                </OpButton>
              );
            }
            return null;

          case 'intercomNotification':
            return (
              <OpButton
                key={key}
                onClick={() => {
                  if (button.onClick) {
                    button.onClick(close);
                  }
                }}
                style={{ marginRight: 8 }}
              >
                {t('View Call')}
              </OpButton>
            );

          default:
            return null;
        }
      })}
    </OpSpace>
  );
}
